export default "__VITE_ASSET__b4a9e323__"